import { BehaviorSubject } from 'rxjs';

export abstract class DlInput {
  isPrestine = true;
  placeholderShown = true;

  labelUp = new BehaviorSubject<boolean>(false);
  hasFocus = new BehaviorSubject<boolean>(false);
}
